import styled from "@emotion/styled";
import { StyledTableBodyCell } from "./cells/cell.styles";
import { Colors } from "theme/colors";
import { StyledTableBodyRow } from "./row.styles";
import { fontKrub } from "theme/fonts";

export const StyledTable = styled.div`
  display: table;
  margin-bottom: 1.3rem;
  width: 100%;
  table-layout: fixed;
`;

export const StyledContainer = styled.div``;

export const StyledToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  gap: 0.5rem;
  margin-bottom: 1rem;
`;

export const StyledTableBody = styled.div`
  display: table-row-group;

  border-radius: 0.325rem;

  box-shadow: 0 0.294rem 0.59rem 0 rgba(0, 0, 0, 0.2);

  & ${StyledTableBodyRow}:first-of-type {
    ${StyledTableBodyCell}:first-of-type {
      border-top-left-radius: 0.325rem;
    }
    ${StyledTableBodyCell}:last-of-type {
      border-top-right-radius: 0.325rem;
    }
  }

  & ${StyledTableBodyRow}:last-of-type {
    ${StyledTableBodyCell}:first-of-type {
      border-bottom-left-radius: 0.325rem;
    }
    ${StyledTableBodyCell}:last-of-type {
      border-bottom-right-radius: 0.325rem;
    }
  }

  ${StyledTableBodyRow} {
    &:nth-of-type(odd) {
      & > div {
        background-color: ${Colors.LIGHT_GRAY};
      }
    }

    &:nth-of-type(even) {
      & > div {
        background-color: ${Colors.WHITE};
      }
    }
  }
`;

export const StyledAddRow = styled.div`
  padding-left: 1rem;
`;

export const EmptyNotice = styled.div`
  padding: 1rem 1rem 0.8rem 1rem;
  color: ${Colors.TEXT_GRAY};
  ${fontKrub()};
  font-size: 0.9375rem;
  cursor: default;
  word-wrap: break-word;
  margin-top: -4rem;
  position: absolute;
`;
